<template>
  <div class="registration">
    <div class="title-section">
      <h1 class="page-title">{{ $props.pageTitle }}</h1>
      <p class="page-subtitle">{{ $props.pageSubtitle }}</p>
    </div>
    <forgotten-password-form/>
  </div>
</template>

<script>
import ForgottenPasswordForm from '@/components/login/forgotten-password-form'
import { addDataLayerEvent } from '@/services/dataLayer'
export default {
  name: 'page-forgotten-password',
  components: { ForgottenPasswordForm },
  props: {
    pageTitle: String,
    pageSubtitle: String
  },
  mounted () {
    addDataLayerEvent({
      event: 'screen',
      name: 'forgot_password'
    })
  }
}
</script>

<style scoped>

</style>
